import React, { useState } from 'react'
import './ArticleSliderItem.css'
import { BiTime } from 'react-icons/bi'
import { BsBookmark, BsFillBookmarkFill } from 'react-icons/bs'
import { axiosConfig } from '../../Configuration/axios/axiosConfiguration'
import { Link, useNavigate } from 'react-router-dom'
import { AiOutlineEye } from 'react-icons/ai'
import imageNotFound from '../../Assets/images/ImageNotFound.jpg'
import { toast } from 'react-toastify'
export default function ArticleSliderItem(props) {
    const [isLike, setIsLike] = useState(
        props.item.blogSaves?.filter(p => p.registererId == localStorage.getItem("userId")).length != 0 ? true : false
    );
    const nav = useNavigate();
    function saveArticle() {
        axiosConfig
            .post("api/Blog/blogSave/" + props.item.id)
            .then((result) => {
                toast.success("با موفقیت وبلاگ سیو شد", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
                setIsLike(true);
            })
        .catch((res) => {
                if (res.response.status == 401) {
                    toast.warning("وارد حساب کاربری خود شوید", {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                    });
                    nav("/login");
                }
            });
    }
    function deleteSaveArticle() {
        axiosConfig
            .delete("api/Blog/deleteblogSave/" + props.item.id)
            .then((result) => {
                toast.success("با موفقیت وبلاگ سیو شده حذف شد", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
                setIsLike(false);
            })
            .catch((res) => {
                if (res.response.status == 401) {
                    toast.warning("وارد حساب کاربری خود شوید", {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                    });
                    nav("/login");
                }
            });
    }

    return (
        <div className='article-slider-item'>
            {
                props.item.image != null ? (
                    <img src={
                        axiosConfig.defaults.baseURL +
                        "Images/BlogImage/" +
                        props.item.id +
                        "/" +
                        props.item.image} alt={props.item.title} />
                ) : (
                    <img src={imageNotFound} alt={props.item.title} />
                )
            }
           
            <div className='article-info'>
                <div className='article-title'>
                    <h1>
                        {
                            props.item.title
                        }
                    </h1>
                </div>
                <div className='article-btns'>
                    <Link to={"/article/" + props.item.title}>
                        <button>خواندن مقاله</button>
                    </Link>
                    <div className='article-date'>
                        <BiTime />
                        {
                            new Date(props.item.registerDate).toLocaleDateString('fa-IR')
                        }
                    </div>
                </div>
            </div>
            <div className='article-comment-icon'>
                <div className='comment-count'>
                    {
                        props.item.blogVisits.length
                    }
                    <AiOutlineEye />
                </div>
                <div className='save-article'>
                    {isLike ? (
                        <BsFillBookmarkFill
                            onClick={deleteSaveArticle}
                        />
                    ) : (
                        <BsBookmark onClick={saveArticle} />
                    )}
                </div>

            </div>
        </div>
    )
}
